var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogType == "realnaem" ? "实名认证" : "授权收款账户",
            visible: _vm.isShow,
            width: _vm.dialogType == "realnaem" ? "420px" : "460px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _vm.dialogType == "realnaem"
            ? _c("div", {}, [
                _c("div", { staticClass: "y-t-ac y-mb-20" }, [
                  _c("i", { staticClass: "tip-icon-big el-icon-warning" }),
                ]),
                _c("div", { staticClass: "tip-isRealNameNo" }, [
                  _vm._v("仅支持使用实名认证通过的用户支付宝充值，请先认证！"),
                ]),
              ])
            : _c("div", {}, [
                _c("div", { staticClass: "tip-isRealNameNo" }, [
                  _vm._v("账户验证成功，请去授权支付宝账户"),
                ]),
              ]),
          _vm.dialogType == "realnaem"
            ? _c(
                "span",
                {
                  staticClass: "border-top special-title-flag dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isShow = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goToIsRealName },
                    },
                    [_vm._v("去认证")]
                  ),
                ],
                1
              )
            : _c(
                "span",
                {
                  staticClass: "border-top special-title-flag dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toAlipay } },
                    [_vm._v("去授权支付宝账户")]
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }